import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import { TYPE_LABELS } from "@/types/media";

interface NewsCardProps {
  item: NewsItem;
  /** horizontal = list row with cover; compact = text-only row */
  variant?: "horizontal" | "compact";
}

export default function NewsCard({ item, variant = "horizontal" }: NewsCardProps) {
  if (variant === "compact") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex items-start gap-3 border-b border-background-200 py-3 last:border-0"
      >
        <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-semibold text-accent-700">
          <i className="ri-article-line text-sm"></i>
        </span>
        <div className="min-w-0">
          <h4 className="line-clamp-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
            {item.title}
          </h4>
          <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
            <span>{item.date}</span>
            <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
              {TYPE_LABELS[item.category]}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300 sm:flex-row"
    >
      <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-auto sm:w-48">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 资讯配图`}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span>{item.date}</span>
          <span className="rounded-sm bg-secondary-100 px-1.5 py-0.5 text-secondary-900">
            {TYPE_LABELS[item.category]}
          </span>
        </div>
        <h3 className="line-clamp-2 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {item.summary}
        </p>
        <span className="mt-auto inline-flex items-center gap-1 text-sm font-medium text-primary-700">
          阅读全文
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-line text-base"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}